import { Component } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { Globals } from '../../services/globals';
import { ExerciseService } from '../../services/exercise.service';
import { ImageService } from '../../services/image.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  templateUrl: './detail.html',
  styleUrls: ['./detail.scss'],
})

export class DetailPage {

  /**
   * 아동 번호
   */
  private bmiNum: number = 0;

  /**
   * 뇌 번호
   */
  private exBrainNum: number;

  /**
   * 운동 번호
   */
  eNum: number;

  /**
   * 운동 카테고리 번호
   */
  ecNum: number;

  /**
   * 운동 이름
   */
  eName: string;

  /**
   * 운동 카테고리 이름
   */
  ecName: string;

  /**
   * 공유 서비스
   */
  ss: SharedService = SharedService;

  /**
   * 운동 설명 (뇌 설명 포함)
   */
  exDetailList: any[] = [];

  /**
   * 안구/검사 운동 설명 (뇌 설명 포함)
   */
  eyetestList: any[] = [];

  /**
   * 운동검사의 경우 참고문헌 문구
   */
  testReference: string[] = [];

  /**
   * 검사운동의 경우 운동이름 재설정
   */
  testExName: string;

  /**
   * @constructor
   */
  constructor(
    private $exerciseService: ExerciseService,
    private $imageService: ImageService,
    private $g: Globals,
    private $activatedRoute: ActivatedRoute) {
    // 운동 정보 받기
    this.$activatedRoute.params.subscribe((params) => {
      if (!params) return;
      this.eNum = Number(params['eNum']);
      this.eName = params['eName'];
      this.ecNum = Number(params['ecNum']);
      this.ecName = params['ecName'];

      // 페이지 진입 시에 안구/검사/일반 운동 데이터 가져옴, 아동 번호 다를 시 nav pop 처리
      if (this.ecNum === 1 || this.ecNum === 7 || this.ecNum === 13 ||
        this.ecNum <= 23 && this.ecNum >= 19) {
        this.exChartEyeTestInfo(this.ecNum);
        this.testReferenceInfo(this.eNum);
        this.getTestExName(this.eNum);
      } else {
        this.exChartDetailInfo(this.eNum);
      }
      // 아동번호가 갱신되어있고 글로벌 변수와 다를 경우 back 실행
      if (this.bmiNum !== 0 && this.bmiNum !== this.$g.child.num) {
        // TODO: nav 제거 뒤로가기 구현
        // setTimeout(() => this._nav.pop(), 700);
        setTimeout(() => {}, 700);
      }
      this.bmiNum = this.$g.child.num;
    });
  }

  /**
   * 운동 설명 (뇌 정보 포함) 가져옴
   */
  private exChartDetailInfo(eNum: number) {
    this.$exerciseService.exChartDetailInfo(eNum).subscribe(
      (data) => {
        this.exDetailList = data[0];
        this.exBrainNum = data[0].b_num;
      },
      (err) => {
        console.log(err);
      });
  }

  /**
   * 안구/검사 운동 설명 (뇌 정보 포함) 가져옴
   */
  private exChartEyeTestInfo(ecNum: number) {
    this.$exerciseService.exChartEyeTestInfo(ecNum).subscribe(
      (data) => {
        this.exDetailList = data[0];
        if (ecNum >= 19 && ecNum <= 23) {
          this.eyetestList = data[1];
        } else {
          this.eyetestList = data;
        }
        this.exBrainNum = data[0].b_num;
      },
      (err) => {
        console.log(err);
      });
  }

  /**
   * 운동검사의 경우 참고문헌 운동번호에 맞게 넣어줌
   */
  private testReferenceInfo(eNum: number) {
    switch (eNum){
      case 67:
        this.testReference = [
          '1. Bruininks-Oseretsky Test of Motor Proficiency - subtest 8: Strength',
          '2. Choi, S. (2016). Effect of Participation of Core ' +
          'Muscle Exercise Program on Tic Disorder.' +
          'The Korea Journal of Sports Science, 22(4), pp.941-949.',
        ];
        break;
      case 73:
        this.testReference = [
          '1. Bruininks-Oseretsky Test of Motor Proficiency - subtest 4: Bilateral Coordination',
          '2. Smith, J. and Feldman, J. (1987). In vitro brainstem-spinal cord preparations' +
          'for study of motor systems for mammalian respiration and locomotion. ' +
          'Journal of Neuroscience Methods, 21(2-4), pp.321-333.',
        ];
        break;
      case 79:
        this.testReference = [
          '1. Bruininks-Oseretsky Test of Motor Proficiency - subtest 6: Running Speed and Agility',
          '2. Husain, M. and Nachev, P. (2007). Space and the parietal cortex. ' +
          'Trends in Cognitive Sciences, 11(1), pp.30-36.',
        ];
        break;
      case 84:
        this.testReference = [
          '1. Bruininks-Oseretsky Test of Motor Proficiency - subtest 5: Balance',
          '2. Molloy, C., Dietrich, K. and Bhattacharya, A. (2003). ' +
          'Postural Stability in Children with Autism Spectrum Disorder. ' +
          'Journal of Autism and Developmental Disorders, 33(6), pp.643-652.',
        ];
        break;
      case 89:
        this.testReference = [
          '1. Bruininks-Oseretsky Test of Motor Proficiency - subtest 7: Upper-Limb Coordination',
          '2. Miyake, A., Friedman, N., Emerson, M., Witzki, A., Howerter, A. ' +
          'and Wager, T. (2000). The Unity and Diversity of Executive Functions and ' +
          'Their Contributions to Complex “Frontal Lobe” Tasks: A Latent Variable Analysis. ' +
          'Cognitive Psychology, 41(1), pp.49-100.',
        ];
        break;
    }
  }

  /**
   * 검사운동의 경우 운동번호에 맞는 운동이름 재설정
   */
  private getTestExName(eNum: number) {
    if (eNum === 68) {
      this.testExName = '중심근육을 발달 시키는 운동';
    } else if (eNum === 74) {
      this.testExName = '보행패턴 수행을 향상 시키는 운동';
    } else if (eNum === 80 || eNum === 85) {
      this.testExName = '감각자극을 채워주는 감각체조';
    } else if (eNum === 90) {
      this.testExName = '전두엽 활용을 도와주는 운동';
    }
  }

  /**
   * 뇌 이미지 서버에서 가져옴
   */
  getBrainImage(): string {
    const eyeCategoryNums = [1, 7, 13];
    const exerciseNumber = this.exBrainNum;

    if (!exerciseNumber) return '';

    return this.$imageService.exerciseBrainImage(
        eyeCategoryNums.indexOf(exerciseNumber) !== -1 ?
            1 : exerciseNumber);
  }

  /**
   * 운동 이미지 서버에서 가져옴
   */
  getExImage(): string {
    const list = [1, 7, 13];
    const categoryNum = this.ecNum;
    const exerciseNum = this.eNum;

    if (!categoryNum) return '';

    return this.$imageService.exerciseImage(
        list.indexOf(categoryNum) !== -1
            || categoryNum <= 23 && categoryNum >= 19 ?
        13 : exerciseNum);
  }

  /**
   * 서버 운동 이미지 주소 요청
   */
  requestExerciseImage(exerciseNumber: number): string {
    if (!exerciseNumber) return '';

    return this.$imageService.exerciseImage(exerciseNumber);
  }
}
